import React from "react";
import WidgetSectionTitle from "widgets/WidgetSectionTitle";
import QAChecklistTable from "./QAChecklistSection";

export default function QAChecklistPage() {
  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-3 mt-3 gap-3">
        <WidgetSectionTitle
          icon="check-square"
          title="QA Checklist"
          subtitle="10 Features"
          className="mb-0"
        />
      </div>
      <QAChecklistTable />
    </div>
  );
}